__turbopack_context__.v({
  "icon": "WhyPort-module-scss-module__CaLrwa__icon",
  "root": "WhyPort-module-scss-module__CaLrwa__root",
  "textWrapper": "WhyPort-module-scss-module__CaLrwa__textWrapper",
});
